module.exports = __webpack_public_path__ + "b87e2277eaaea506f1159f76283b2476.svg";